"use strict";

exports.__esModule = true;
exports.AlertValueElement = AlertValueElement;
var _react = _interopRequireWildcard(require("react"));
var _reactSounds = require("react-sounds");
var _AlertSubscription = require("../../Alerts/AlertSubscription");
var _DeviceColorSources = require("../../Device/DeviceColorSources");
var _DeviceContext = require("../../Device/DeviceContext");
var _MeasurementValueWithTimestamp = require("../../Measures/MeasurementValue/MeasurementValueWithTimestamp");
var _timeDefinitions = require("../../timeDefinitions");
var _common = require("../common");
var _widget = require("./widget");
var _Utils = require("../../../Utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function AlertValueElement(props) {
  var hideLabel = props.hideLabel,
    hideTimestamp = props.hideTimestamp,
    _props$alertMaxAgeInM = props.alertMaxAgeInMinutes,
    alertMaxAgeInMinutes = _props$alertMaxAgeInM === void 0 ? _widget.ALERT_MAX_AGE_DEFAULT : _props$alertMaxAgeInM,
    hideOlderAlerts = props.hideOlderAlerts,
    soundNotification = props.soundNotification,
    _props$sound = props.sound,
    sound = _props$sound === void 0 ? _widget.ALERT_SOUND_DEFAULT : _props$sound;
  var maxAlertAgeForSound = _timeDefinitions.MINUTE_IN_MILLIS;
  var _useState = (0, _react.useState)(null),
    currentPacket = _useState[0],
    setCurrentPacket = _useState[1];
  var _useState2 = (0, _react.useState)(null),
    alertToShow = _useState2[0],
    setAlertToShow = _useState2[1];
  var updatePacket = (0, _react.useCallback)(function (packet) {
    return setCurrentPacket(packet);
  }, []);
  var timerRef = (0, _react.useRef)();
  var _useSound = (0, _reactSounds.useSound)(sound),
    play = _useSound.play;
  var debounceSoundPlay = (0, _Utils.debounce)(function () {
    return play();
  }, {
    delay: 2000
  });
  (0, _react.useEffect)(function () {
    if (!currentPacket || !currentPacket.timestamp) {
      return;
    }
    var alertAge = Date.now() - currentPacket.timestamp;
    var maxAgeMs = alertMaxAgeInMinutes * _timeDefinitions.MINUTE_IN_MILLIS;
    var timeUntilExpiry = maxAgeMs - alertAge;
    if (hideOlderAlerts && timeUntilExpiry <= 0) {
      setAlertToShow(null);
      return;
    }
    setAlertToShow({
      value: currentPacket.value,
      timestamp: currentPacket.timestamp,
      timezone: currentPacket.timezone
    });
    if (soundNotification && alertAge < maxAlertAgeForSound) {
      debounceSoundPlay();
    }
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    if (hideOlderAlerts) {
      timerRef.current = setTimeout(function () {
        setAlertToShow(null);
      }, timeUntilExpiry);
    }
    return function () {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [currentPacket, alertMaxAgeInMinutes, hideOlderAlerts]);
  return /*#__PURE__*/_react["default"].createElement(_reactSounds.SoundProvider, {
    preload: _widget.PREDEFINED_ALERT_SOUNDS,
    initialEnabled: true
  }, /*#__PURE__*/_react["default"].createElement(_DeviceContext.DeviceContext.Consumer, null, function (device) {
    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      "data-testid": "AlertValueElement.div"
    }, (0, _common.getWidgetInteractionProps)(props)), /*#__PURE__*/_react["default"].createElement(_AlertSubscription.AlertSubscription, {
      type: "alert",
      entity: {
        device: device.uuid
      }
    }, function (packet) {
      if (packet !== currentPacket) {
        setTimeout(function () {
          return updatePacket(packet);
        }, 0);
      }
      return /*#__PURE__*/_react["default"].createElement(_DeviceColorSources.DeviceColorController, _extends({
        deviceUuid: device.uuid
      }, (0, _common.getWidgetColorProps)(props), {
        value: (alertToShow == null ? void 0 : alertToShow.value) || ""
      }), function (_ref) {
        var color = _ref.color,
          backgroundColor = _ref.backgroundColor;
        return /*#__PURE__*/_react["default"].createElement(_MeasurementValueWithTimestamp.MeasurementValueWithTimestamp, _extends({}, (0, _common.getWidgetPositionProps)(props), (0, _common.getWidgetFontProps)(props), (0, _common.getWidgetInteractionProps)(props), {
          color: color,
          backgroundColor: backgroundColor,
          hideTimestamp: hideTimestamp,
          value: alertToShow == null ? void 0 : alertToShow.value,
          units: "",
          timestamp: !hideTimestamp ? alertToShow == null ? void 0 : alertToShow.timestamp : null,
          timezone: alertToShow == null ? void 0 : alertToShow.timezone,
          label: !hideLabel && "Alert"
        }));
      });
    }));
  }));
}